export const decileContextOverviewColumns = [
  {
    label: 'National Neighborhood Average',
    field: 'a_nh_overall_decile',
    sortable: false,
    justify: 'center',
  },
  {
    label: 'National High School Average',
    field: 'a_hs_overall_decile',
    sortable: false,
    justify: 'center',
  },
  {
    label: 'Your Colleges Neighborhood Average',
    field: 'di_nh_avg',
    sortable: false,
    justify: 'center',
  },
  {
    label: 'Your Colleges High School Average',
    field: 'di_hs_avg',
    sortable: false,
    justify: 'center',
  },
  {
    label: 'Applicant neighborhood generated from a PO Box',
    field: 'po_box',
    sortable: false,
    justify: 'center',
  },
]

export const contextOverviewColumns = [
  {
    label: 'National Neighborhood Average',
    field: 'a_nh_overrall_ptile',
    sortable: false,
    justify: 'center',
  },
  {
    label: 'National High School Average',
    field: 'a_hs_overrall_ptile',
    sortable: false,
    justify: 'center',
  },
  {
    label: 'Your Colleges Neighborhood Average',
    field: 'di_nh_avg',
    sortable: false,
    justify: 'center',
  },
  {
    label: 'Your Colleges High School Average',
    field: 'di_hs_avg',
    sortable: false,
    justify: 'center',
  },
  {
    label: 'Applicant neighborhood generated from a PO Box',
    field: 'po_box',
    sortable: false,
    justify: 'center',
  },
]

export const satScoreInHighSchoolContextColumns = [
  { label: '25th Percentile', field: 'a_hs_satc_25', sortable: false, justify: 'center' },
  { label: '50th Percentile', field: 'a_hs_satc_50', sortable: false, justify: 'center' },
  { label: '75th Percentile', field: 'a_hs_satc_75', sortable: false, justify: 'center' },
  { label: 'Students Score', field: 'display_score', sortable: false, justify: 'center' },
  { label: 'Concorded ACT Score', field: 'score_source', sortable: false, justify: 'center' },
  { label: 'Above 75th Percentile', field: 'above_75th', sortable: false, justify: 'center' },
  {
    label: 'Percentage of Seniors taking SAT',
    field: 'a_pct_taking_sat',
    sortable: false,
    justify: 'center',
  },
  {
    label: 'Less than 25% of Seniors taking SAT',
    field: 'less_than_25',
    sortable: false,
    justify: 'center',
  },
]

export const hsInfoColumns = [
  { label: 'Locale', field: 'rural', sortable: false, justify: 'center' },
  { label: 'Senior Class Size', field: 'a_sr_class_size', sortable: false, justify: 'center' },
  { label: 'Free/Reduced Lunch', field: 'a_avg_frl_pct', sortable: false, justify: 'center' },
  {
    label: 'SAT at Colleges Attended',
    field: 'a_avg_coll_sat_hs',
    sortable: false,
    justify: 'center',
  },
  { label: 'Seniors Taking AP', field: 'a_pct_taking_sat', sortable: false, justify: 'center' },
  { label: 'Average AP Exams Taken', field: 'adv_aptaken', sortable: false, justify: 'center' },
  { label: 'Average AP Score', field: 'adv_avgapscore', sortable: false, justify: 'center' },
  {
    label: 'Unique Exams Administered',
    field: 'adv_aptestavail',
    sortable: false,
    justify: 'center',
  },
  { label: 'AP Capstone School', field: 'ddv_apcapstone', sortable: false, justify: 'center' },
]

export const challengeIndicatorsNationalColumns = [
  {
    label: 'National Neighborhood College Attendance',
    field: 'a_nh_college_access',
    sortable: false,
    justify: 'center',
  },
  {
    label: 'National High School College Attendance',
    field: 'a_hs_college_access',
    sortable: false,
    justify: 'center',
  },
  {
    label: 'National Neighborhood Family Stability',
    field: 'a_nh_family_ptile',
    sortable: false,
    justify: 'center',
  },
  {
    label: 'National High School Family Stability',
    field: 'a_hs_family_ptile',
    sortable: false,
    justify: 'center',
  },
  {
    label: 'National Neighborhood Median Family Income',
    field: 'a_nh_medfaminc_ptile',
    sortable: false,
    justify: 'center',
  },
  {
    label: 'National High School Median Family Income',
    field: 'a_hs_medfaminc_ptile',
    sortable: false,
    justify: 'center',
  },
  {
    label: 'National Neighborhood Housing Stability',
    field: 'a_nh_housing_ptile',
    sortable: false,
    justify: 'center',
  },
  {
    label: 'National High School Housing Stability',
    field: 'a_hs_housing_ptile',
    sortable: false,
    justify: 'center',
  },
  {
    label: 'National Neighborhood Educational Level',
    field: 'a_nh_educ_ptile',
    sortable: false,
    justify: 'center',
  },
  {
    label: 'National High School Educational Level',
    field: 'a_hs_educ_ptile',
    sortable: false,
    justify: 'center',
  },
  {
    label: 'National Neighborhood Crime',
    field: 'a_nh_crime_ptile',
    sortable: false,
    justify: 'center',
  },
  {
    label: 'National High School Crime',
    field: 'a_hs_crime_ptile',
    sortable: false,
    justify: 'center',
  },
  {
    label: 'National Neighborhood Overall',
    field: 'a_nh_overrall_ptile',
    sortable: false,
    justify: 'center',
  },
  {
    label: 'National High School Overall',
    field: 'a_hs_overrall_ptile',
    sortable: false,
    justify: 'center',
  },
]

export const challengeIndicatorsStateColumns = [
  {
    label: 'State Neighborhood College Attendance',
    field: 'st_a_nh_college_access',
    sortable: false,
    justify: 'center',
  },
  {
    label: 'State High School College Attendance',
    field: 'st_a_hs_college_access',
    sortable: false,
    justify: 'center',
  },
  {
    label: 'State Neighborhood Family Stability',
    field: 'st_a_nh_family_ptile',
    sortable: false,
    justify: 'center',
  },
  {
    label: 'State High School Family Stability',
    field: 'st_a_hs_family_ptile',
    sortable: false,
    justify: 'center',
  },
  {
    label: 'State Neighborhood Median Family Income',
    field: 'st_a_nh_medfaminc_ptile',
    sortable: false,
    justify: 'center',
  },
  {
    label: 'State High School Median Family Income',
    field: 'st_a_hs_medfaminc_ptile',
    sortable: false,
    justify: 'center',
  },
  {
    label: 'State Neighborhood Housing Stability',
    field: 'st_a_nh_housing_ptile',
    sortable: false,
    justify: 'center',
  },
  {
    label: 'State High School Housing Stability',
    field: 'st_a_hs_housing_ptile',
    sortable: false,
    justify: 'center',
  },
  {
    label: 'State Neighborhood Educational Level',
    field: 'st_a_nh_educ_ptile',
    sortable: false,
    justify: 'center',
  },
  {
    label: 'State High School Educational Level',
    field: 'st_a_hs_educ_ptile',
    sortable: false,
    justify: 'center',
  },
  {
    label: 'State Neighborhood Crime',
    field: 'st_a_nh_crime_ptile',
    sortable: false,
    justify: 'center',
  },
  {
    label: 'State High School Crime',
    field: 'st_a_hs_crime_ptile',
    sortable: false,
    justify: 'center',
  },
  {
    label: 'State Neighborhood Overall',
    field: 'st_a_nh_overrall_ptile',
    sortable: false,
    justify: 'center',
  },
  {
    label: 'State High School Overall',
    field: 'st_a_hs_overrall_ptile',
    sortable: false,
    justify: 'center',
  },
]
